import React from "react";
import AppAuthentication from "./main/authenticate/AppAuthentication";

const AddToClio = (props) => {
  return props.authState === "signedIn" ? <AppAuthentication origin={"addToClio"} authData={props.authData} /> : null;
};

export default AddToClio;
